import {
  CircleArrowDown,
  ChartNoAxesGantt,
  ClipboardList,
  LayoutTemplate,
  ArrowLeftRight,
  ChartBar,
  ChartColumn,
  Compass,
  Tag,
  TrendingDown,
  TrendingUp,
  AlarmClock,
  Network,
  Newspaper,
  Baseline,
  CopyPlus,
  Lightbulb,
  ListCollapse,
  ListTree,
  ALargeSmall,
  Archive,
  Ban,
  ArrowDown,
  ArrowLeft,
  CornerLeftUp,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  AtSign,
  Bell,
  BellOff,
  BellRing,
  Bold,
  Bookmark,
  BookmarkCheck,
  Bot,
  Bug,
  BrushCleaning,
  Calendar,
  CalendarClock,
  CaseSensitive,
  Check,
  CheckCheck,
  Circle,
  CircleX,
  CircleDot,
  CircleCheckBig,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUpDown,
  ChevronUp,
  CircleCheck,
  CircleHelp,
  CirclePlus,
  CircleUserRound,
  ClipboardCheck,
  Clock,
  ClockArrowUp,
  Repeat2,
  Code,
  Copy,
  Download,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  ScanEye,
  File,
  FileArchive,
  Files,
  FileText,
  Forward,
  Share,
  Globe,
  Hand,
  Hash,
  Headphones,
  Cake,
  TreePalm,
  CalendarPlus,
  PhoneCall,
  History,
  House,
  Image,
  RefreshCw,
  Shuffle,
  Camera,
  SquareDashed,
  AppWindow,
  Monitor,
  Inbox,
  Info,
  Italic,
  Keyboard,
  QrCode,
  Wifi,
  KeyRound,
  CreditCard,
  IdCard,
  Landmark,
  Delete,
  FingerprintPattern,
  LockOpen,
  LifeBuoy,
  LayoutGrid,
  Link,
  ArrowUpRight,
  Sigma,
  List,
  ListFilter,
  ListOrdered,
  ListTodo,
  Lock,
  LogOut,
  Mail,
  Maximize2,
  Menu,
  MessageCircle,
  MessageSquareDot,
  MessageSquareText,
  MessagesSquare,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  MonitorUp,
  Moon,
  Focus,
  GalleryHorizontalEnd,
  MoveHorizontal,
  Palette,
  PanelLeft,
  PanelRight,
  PanelRightOpen,
  Paperclip,
  PencilLine,
  Phone,
  PhoneOff,
  Pin,
  Printer,
  PinOff,
  Rows3,
  UserMinus,
  Plug,
  Plus,
  Puzzle,
  RotateCw,
  ScanFace,
  Search,
  SendHorizontal,
  Settings,
  ShieldCheck,
  Smile,
  SmilePlus,
  SquareCode,
  SquarePen,
  SquareTerminal,
  Star,
  Strikethrough,
  Sun,
  TextQuote,
  Trash2,
  UserPlus,
  Users,
  Video,
  VideoOff,
  Webhook,
  X,
  type LucideIcon,
  Heading1,
  Heading2,
  Heading3,
  SquareCheckBig,
  Table,
  Database,
  SeparatorHorizontal,
  Underline,
  GripVertical,
  MessageSquarePlus,
  MessageSquare,
  Type,
  Undo2,
  Redo2,
  ArchiveRestore,
  FilePlus,
  Unlink,
  CloudCheck,
  CloudOff,
  Cloud,
  Laptop,
  LoaderCircle,
  SlidersHorizontal,
  Sparkles,
  TriangleAlert,
  Handshake,
  Scale,
  CalendarDays,
  Building2,
  StickyNote,
  Spline,
  MousePointer2,
  ZoomIn,
  ZoomOut,
  Infinity as InfinityIcon,
  Grid3x3,
  UserCheck,
  MailOpen,
  Square,
  Diamond,
  Waypoints,
  Folder,
  FolderOpen,
  FolderPlus,
  Shapes,
  Sheet,
  Upload,
  Maximize,
  UsersRound,
  AlignLeft,
  AlignCenter,
  AlignRight,
  WrapText,
  ArrowDownAZ,
  ArrowDownZA,
  Megaphone,
  Timer,
  Reply,
  ReplyAll,
  Play,
  Pause,
  PictureInPicture2,
  Captions,
  Scissors,
  Volume2,
  VolumeX,
  Clapperboard,
  Flag,
  SquareKanban,
  Zap,
  Columns2,
  Languages,
  WandSparkles,
  Trophy,
  Medal,
  Gift,
  ShoppingBag,
  Crown,
  Package,
} from 'lucide-react';
import { PreviewLarge, PreviewOff, PreviewSmall } from './previewIcons';
import { useId, type CSSProperties, type ReactNode } from 'react';

/**
 * Иконки интерфейса — набор Lucide (ISC): тонкие контурные иконки со скруглёнными концами,
 * как в интерфейсе Пассворка. Активный раздел и включённое состояние — чуть жирнее и с лёгкой заливкой.
 */
const icons = {
  sparkles: Sparkles,
  /** Приоритет задачи (Todo). */
  flag: Flag,
  risk: TriangleAlert,
  promise: Handshake,
  decision: Scale,
  calendarDays: CalendarDays,
  building: Building2,
  sticky: StickyNote,
  connector: Spline,
  pointer: MousePointer2,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  infinity: InfinityIcon,
  grid: Grid3x3,
  userCheck: UserCheck,
  mailOpen: MailOpen,
  square: Square,
  diamond: Diamond,
  waypoints: Waypoints,
  folder: Folder,
  folderOpen: FolderOpen,
  folderPlus: FolderPlus,
  board: Shapes,
  sheet: Sheet,
  upload: Upload,
  maximize: Maximize,
  group: UsersRound,
  megaphone: Megaphone,
  newspaper: Newspaper,
  alignLeft: AlignLeft,
  alignCenter: AlignCenter,
  alignRight: AlignRight,
  wrap: WrapText,
  sortAsc: ArrowDownAZ,
  sortDesc: ArrowDownZA,
  orgChart: Network,
  hash: Hash,
  lock: Lock,
  plus: Plus,
  minus: Minus,
  search: Search,
  home: House,
  // «Документы» рисуется своим значком (DocsGlyph); Lucide — только чтобы имя было в списке.
  docs: Files,
  chat: MessageCircle,
  bell: Bell,
  bellRinging: BellRing,
  bellOff: BellOff,
  bookmark: Bookmark,
  bookmarks: BookmarkCheck,
  todo: ListTodo,
  todoAdded: ListTodo,
  threads: MessagesSquare,
  reply: MessageSquareText,
  more: Ellipsis,
  moreV: EllipsisVertical,
  smile: Smile,
  smilePlus: SmilePlus,
  at: AtSign,
  paperclip: Paperclip,
  send: SendHorizontal,
  bold: Bold,
  italic: Italic,
  strike: Strikethrough,
  link: Link,
  arrowUpRight: ArrowUpRight,
  sigma: Sigma,
  external: ExternalLink,
  listUl: List,
  listOl: ListOrdered,
  quote: TextQuote,
  code: Code,
  codeBlock: SquareCode,
  textAa: CaseSensitive,
  textSize: ALargeSmall,
  x: X,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronUpDown: ChevronsUpDown,
  star: Star,
  pin: Pin,
  printer: Printer,
  pinOff: PinOff,
  listRows: Rows3,
  userMinus: UserMinus,
  edit: PencilLine,
  compose: SquarePen,
  trash: Trash2,
  users: Users,
  /** Каталог LDAP / Active Directory: дерево записей. */
  directory: Network,
  user: CircleUserRound,
  userPlus: UserPlus,
  settings: Settings,
  sliders: SlidersHorizontal,
  logout: LogOut,
  shuffle: Shuffle,
  moon: Moon,
  focus: Focus,
  cards: GalleryHorizontalEnd,
  sun: Sun,
  archive: Archive,
  /** «Сбросить значок и цвет». */
  ban: Ban,
  download: Download,
  file: File,
  fileText: FileText,
  filePdf: FileText,
  fileZip: FileArchive,
  files: Files,
  image: Image,
  imageReplace: RefreshCw,
  camera: Camera,
  captureArea: SquareDashed,
  captureWindow: AppWindow,
  captureScreen: Monitor,
  check: Check,
  checkCircle: CircleCheck,
  info: Info,
  question: CircleHelp,
  plusCircle: CirclePlus,
  copy: Copy,
  copied: ClipboardCheck,
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  arrowLeft: ArrowLeft,
  cornerLeftUp: CornerLeftUp,
  arrowRight: ArrowRight,
  eye: Eye,
  eyeOff: EyeOff,
  scanEye: ScanEye,
  shield: ShieldCheck,
  keyboard: Keyboard,
  qr: QrCode,
  wifi: Wifi,
  menu: Menu,
  clock: Clock,
  timer: Timer,
  scheduled: ClockArrowUp,
  repeat: Repeat2,
  swap: ArrowLeftRight,
  alarm: AlarmClock,
  calendar: Calendar,
  unread: MessageSquareDot,
  inbox: Inbox,
  history: History,
  globe: Globe,
  languages: Languages,
  wand: WandSparkles,
  // «Сводка» рисуется своим значком (SummaryGlyph); Lucide — только чтобы имя было в списке.
  summary: FileText,
  compass: Compass,
  // Значок встроенного браузера в полосе рисуется своим (BrowserGlyph); Lucide — только чтобы имя было в списке.
  browser: Compass,
  mail: Mail,
  phone: Phone,
  share: Forward,
  shareTo: Share,
  replyMail: Reply,
  replyAll: ReplyAll,
  sections: LayoutGrid,
  sidebar: PanelLeft,
  panelRight: PanelRight,
  panelRightOpen: PanelRightOpen,
  palette: Palette,
  checks: CheckCheck,
  resize: MoveHorizontal,
  headphones: Headphones,
  cake: Cake,
  palm: TreePalm,
  calendarPlus: CalendarPlus,
  phoneCall: PhoneCall,
  mic: Mic,
  micOff: MicOff,
  video: Video,
  /** Запись кружка: кольцо-таймер с точкой (рисует CircleNoteGlyph). */
  circleNote: Circle,
  videoOff: VideoOff,
  screen: MonitorUp,
  hand: Hand,
  hangup: PhoneOff,
  expand: Maximize2,
  collapse: Minimize2,
  speaker: ScanFace,
  plug: Plug,
  robot: Bot,
  key: KeyRound,
  creditCard: CreditCard,
  idCard: IdCard,
  bank: Landmark,
  fingerprint: FingerprintPattern,
  backspace: Delete,
  unlock: LockOpen,
  lifebuoy: LifeBuoy,
  webhook: Webhook,
  terminal: SquareTerminal,
  puzzle: Puzzle,
  retry: RotateCw,
  // Генератор пароля из Пассворка — рисуется своим значком (PasswordGenGlyph); Lucide — только чтобы имя было в списке.
  passwordGen: RefreshCw,
  cleanup: BrushCleaning,
  circle: Circle,
  circleX: CircleX,
  circleDot: CircleDot,
  circleDone: CircleCheckBig,
  sort: ArrowUpDown,
  filter: ListFilter,
  calendarClock: CalendarClock,
  heading1: Heading1,
  heading2: Heading2,
  heading3: Heading3,
  checkSquare: SquareCheckBig,
  table: Table,
  database: Database,
  columns: Columns2,
  divider: SeparatorHorizontal,
  underline: Underline,
  grip: GripVertical,
  commentPlus: MessageSquarePlus,
  comment: MessageSquare,
  text: Type,
  undo: Undo2,
  redo: Redo2,
  restore: ArchiveRestore,
  filePlus: FilePlus,
  unlink: Unlink,
  cloudCheck: CloudCheck,
  /** «Доступно офлайн»: беседа или файл лежит на устройстве. */
  offline: CircleArrowDown,
  cloudOff: CloudOff,
  cloud: Cloud,
  laptop: Laptop,
  loader: LoaderCircle,
  toggle: ListCollapse,
  toc: ListTree,
  refresh: RefreshCw,
  callout: Lightbulb,
  idea: Lightbulb,
  bug: Bug,
  duplicate: CopyPlus,
  textColor: Baseline,
  analytics: ChartColumn,
  /** Опрос в сообщении. */
  poll: ChartBar,
  survey: ClipboardList,
  template: LayoutTemplate,
  tag: Tag,
  trendUp: TrendingUp,
  trendDown: TrendingDown,
  // Видеоклипы (features/clips): плеер и запись.
  play: Play,
  pause: Pause,
  pip: PictureInPicture2,
  captions: Captions,
  scissors: Scissors,
  volume: Volume2,
  volumeOff: VolumeX,
  clip: Clapperboard,
  /** Доска задач (канбан) во вкладке канала. */
  kanban: SquareKanban,
  /** Вид базы «Таймлайн». */
  timeline: ChartNoAxesGantt,
  /** Автоматизация доски задач. */
  zap: Zap,
  /** «Награды»: медали, доска почёта, магазин. */
  trophy: Trophy,
  medal: Medal,
  gift: Gift,
  bag: ShoppingBag,
  crown: Crown,
  package: Package,
  /** Вид превью ссылки в поле ввода. */
  previewLarge: PreviewLarge,
  previewSmall: PreviewSmall,
  previewOff: PreviewOff,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;
/** regular — обычный контур; bold — контур жирнее; fill — жирнее и с лёгкой заливкой (активный раздел, включённое состояние). */
export type IconWeight = 'regular' | 'bold' | 'fill';

export interface IconProps {
  readonly name: IconName;
  readonly className?: string | undefined;
  readonly style?: CSSProperties;
  readonly size?: number;
  readonly weight?: IconWeight;
  /** Подпись для диктора; без неё иконка декоративная. */
  readonly label?: string;
}

/*
 * Свои значки разделов: «Главная» (дом, как в приложении ChatGPT, только мягче) и «Документы» (два листа внахлёст).
 * У каждого два слоя — контур и заливка: в выбранном разделе слои плавно меняются местами, размер не меняется.
 * Вырезы (дверь, загиб листа, зазор между листами) сделаны масками и не зависят от толщины линии: в заливке они
 * остаются такими же широкими, как в контуре.
 */
const HOME_OUTLINE =
  'M10.55 3.17a2.25 2.25 0 0 1 2.9 0l6.25 5.23a2.25 2.25 0 0 1 .8 1.72v8.63A2.25 2.25 0 0 1 18.25 21H14.5v-4a2.5 2.5 0 0 0-5 0v4H5.75a2.25 2.25 0 0 1-2.25-2.25v-8.63a2.25 2.25 0 0 1 .8-1.72Z';
const HOME_SOLID =
  'M10.55 3.17a2.25 2.25 0 0 1 2.9 0l6.25 5.23a2.25 2.25 0 0 1 .8 1.72v8.63A2.25 2.25 0 0 1 18.25 21H5.75a2.25 2.25 0 0 1-2.25-2.25v-8.63a2.25 2.25 0 0 1 .8-1.72Z';
/** Дверь в залитом доме: арка шириной 5, как просвет двери в контуре. */
const HOME_DOOR = 'M9.5 23V16.9A2.5 2.5 0 0 1 14.5 16.9V23Z';

const SHEET_FRONT = 'M6.65 6.75H11.15L14.75 10.35V18.35A2.4 2.4 0 0 1 12.35 20.75H6.65A2.4 2.4 0 0 1 4.25 18.35V9.15A2.4 2.4 0 0 1 6.65 6.75Z';
const SHEET_FOLD = 'M11.15 6.75V9.35a1 1 0 0 0 1 1H14.75';
const SHEET_BACK = 'M11.9 3.25H17.35A2.4 2.4 0 0 1 19.75 5.65V14.85A2.4 2.4 0 0 1 17.35 17.25H11.9A2.4 2.4 0 0 1 9.5 14.85V5.65A2.4 2.4 0 0 1 11.9 3.25Z';
const FRONT_TILT = 'rotate(-8 9.5 13.75)';
const BACK_TILT = 'rotate(8 14.625 10.25)';

/**
 * «Личные»: облачко со скруглёнными углами и заметным хвостиком снизу слева. Один и тот же контур — для линии и для заливки.
 */
const CHAT_BUBBLE =
  'M7.25 4H16.75A4.25 4.25 0 0 1 21 8.25V12.75A4.25 4.25 0 0 1 16.75 17H12.1L8.35 20.1A.7.7 0 0 1 7.25 19.56V17A4.25 4.25 0 0 1 3 12.75V8.25A4.25 4.25 0 0 1 7.25 4Z';
/** «Активность»: колокольчик (геометрия Lucide Bell) — корпус замкнутый, язычок отдельной линией. */
const BELL_BODY =
  'M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326Z';
const BELL_CLAPPER = 'M10.268 21a2 2 0 0 0 3.464 0';
/** Todo: квадратик дела, галочка и три строки (геометрия Lucide ListTodo). */
const TODO_LINES = 'M13 6h8M13 12h8M13 18h8';
const TODO_CHECK = 'm3 17 2 2 4-4';

interface GlyphProps {
  readonly size: number;
  readonly weight: IconWeight;
  readonly label: string | undefined;
  readonly className: string | undefined;
  readonly style: CSSProperties | undefined;
}

const fade = { transition: 'opacity 0.18s var(--ease, ease)' } as const;

function GlyphSvg({ size, label, className, style, children }: Omit<GlyphProps, 'weight'> & { readonly children: ReactNode }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role={label === undefined ? undefined : 'img'}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
      focusable="false"
      className={className}
      style={style}
    >
      {children}
    </svg>
  );
}

function HomeGlyph({ weight, ...rest }: GlyphProps) {
  const id = useId();
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <mask id={`${id}d`}>
        <rect width="24" height="24" fill="#fff" />
        <path d={HOME_DOOR} fill="#000" />
      </mask>
      <path d={HOME_OUTLINE} fill="none" stroke="currentColor" strokeWidth={line} strokeLinejoin="round" opacity={solid ? 0 : 1} style={fade} />
      <path d={HOME_SOLID} fill="currentColor" stroke="currentColor" strokeWidth={2.1} strokeLinejoin="round" mask={`url(#${id}d)`} opacity={solid ? 1 : 0} style={fade} />
    </GlyphSvg>
  );
}

function DocsGlyph({ weight, ...rest }: GlyphProps) {
  const id = useId();
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      {/* Задний лист виден только вокруг переднего, с зазором. */}
      <mask id={`${id}g`}>
        <rect width="24" height="24" fill="#fff" />
        <path d={SHEET_FRONT} transform={FRONT_TILT} fill="#000" stroke="#000" strokeWidth={solid ? 6.7 : 3.9} strokeLinejoin="round" />
      </mask>
      <mask id={`${id}f`}>
        <rect width="24" height="24" fill="#fff" />
        <path d={SHEET_FOLD} transform={FRONT_TILT} fill="none" stroke="#000" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" />
      </mask>
      <g opacity={solid ? 0 : 1} style={fade} fill="none" stroke="currentColor" strokeWidth={line} strokeLinejoin="round" strokeLinecap="round">
        <path d={SHEET_BACK} transform={BACK_TILT} mask={`url(#${id}g)`} />
        <path d={SHEET_FRONT} transform={FRONT_TILT} />
        <path d={SHEET_FOLD} transform={FRONT_TILT} />
      </g>
      <g opacity={solid ? 1 : 0} style={fade} fill="currentColor" stroke="currentColor" strokeWidth={2.1} strokeLinejoin="round">
        <path d={SHEET_BACK} transform={BACK_TILT} mask={`url(#${id}g)`} />
        <path d={SHEET_FRONT} transform={FRONT_TILT} mask={`url(#${id}f)`} />
      </g>
    </GlyphSvg>
  );
}

/*
 * «Личные», «Активность» и Todo — так же, как «Главная» и «Документы»: в выбранном разделе значок заливается целиком,
 * а не светлой подложкой внутри тёмного контура.
 */
function ChatGlyph({ weight, ...rest }: GlyphProps) {
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <path d={CHAT_BUBBLE} fill="none" stroke="currentColor" strokeWidth={line} strokeLinejoin="round" opacity={solid ? 0 : 1} style={fade} />
      <path d={CHAT_BUBBLE} fill="currentColor" stroke="currentColor" strokeWidth={2.1} strokeLinejoin="round" opacity={solid ? 1 : 0} style={fade} />
    </GlyphSvg>
  );
}

function BellGlyph({ weight, ...rest }: GlyphProps) {
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <path d={BELL_BODY} fill="none" stroke="currentColor" strokeWidth={line} strokeLinejoin="round" opacity={solid ? 0 : 1} style={fade} />
      <path d={BELL_BODY} fill="currentColor" stroke="currentColor" strokeWidth={2.1} strokeLinejoin="round" opacity={solid ? 1 : 0} style={fade} />
      <path d={BELL_CLAPPER} fill="none" stroke="currentColor" strokeWidth={solid ? 2.1 : line} strokeLinecap="round" />
    </GlyphSvg>
  );
}

function TodoGlyph({ weight, ...rest }: GlyphProps) {
  const solid = weight === 'fill';
  const line = solid ? 2.1 : weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <rect x="3" y="5" width="6" height="6" rx="1" fill={solid ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={line} strokeLinejoin="round" style={{ transition: 'fill var(--dur-base) var(--ease-out)' }} />
      <path d={`${TODO_CHECK}${TODO_LINES}`} fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round" />
    </GlyphSvg>
  );
}

/** «Ответить в треде»: облачко и две строки (три выглядели тяжело). */
function ReplyGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <g fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" fill={weight === 'fill' ? 'currentColor' : 'none'} fillOpacity={weight === 'fill' ? 0.18 : undefined} />
        <path d="M7.5 8.5h9M7.5 12.5h5.5" />
      </g>
    </GlyphSvg>
  );
}

/**
 * «Уже в Todo»: наш значок списка, только квадратик дела стал зелёным кружком с белой галочкой — как отметка
 * «готово» в Notion: сразу видно, что сообщение добавлено, а строки списка говорят, куда именно.
 */
function TodoAddedGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      {/* Крупная зелёная отметка «готово» — главное в значке; строки списка — короче, справа. */}
      <circle cx="8.5" cy="12" r="7.5" fill="#2bac76" />
      <path d="m5.2 12.2 2.3 2.3 4.3-4.6" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.5 7h3M18.5 12h3M18.5 17h3" fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round" />
    </GlyphSvg>
  );
}

/**
 * «Aa» — оформление текста, как в Slack: заглавная «A» и строчная «а» вплотную, на одной базовой линии, высота
 * строчной — чуть больше половины заглавной. У значка Lucide буквы стояли далеко друг от друга.
 */
function TextAaGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <g fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        {/* «Оформление»: прописная A и строчная двухъярусная a, как в наборе, и линия строки под ними — знак
            «текст и его вид», а не просто две буквы. */}
        <path d="M3 16.5 7.75 4.5l4.75 12M4.7 12.4h6.1" />
        <path d="M15.2 9.9c.6-.7 1.5-1 2.5-1 1.8 0 3 1 3 2.9v4.7" />
        <path d="M20.7 13.2c-.9-.4-1.9-.5-2.9-.4-1.6.2-2.6 1-2.6 2.2 0 1.1.9 1.8 2.2 1.8 1.4 0 2.6-.7 3.3-1.7" />
        <path d="M3 20.25h18" />
      </g>
    </GlyphSvg>
  );
}

/**
 * Ключ: кольцо, ровный стержень и две бородки под прямым углом — тем же штрихом, что и остальные значки
 * (у KeyRound из Lucide ступенчатая бородка и крошечное отверстие — она «не в стиле проекта»).
 */
function KeyGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <g fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="15.25" cy="8.75" r="5.25" fill={weight === 'fill' ? 'currentColor' : 'none'} fillOpacity={weight === 'fill' ? 0.18 : undefined} />
        <path d="M11.54 12.46 4 20M6.6 17.4l2 2M9.1 14.9l1.6 1.6" />
      </g>
      <circle cx="16.6" cy="7.4" r="1.1" fill="currentColor" />
    </GlyphSvg>
  );
}

/**
 * «Календарь» и «Почта» (входящие) — свои значки с двумя слоями, как у остальных разделов полосы: контур и
 * сплошная заливка с вырезами (линия шапки календаря, просвет лотка). Полупрозрачная заливка Lucide выглядела грязно.
 */
function CalendarGlyph({ weight, ...rest }: GlyphProps) {
  const id = useId();
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <mask id={`${id}c`}>
        <rect width="24" height="24" fill="#fff" />
        <path d="M2 10.6H22" stroke="#000" strokeWidth={1.5} />
      </mask>
      <g opacity={solid ? 0 : 1} style={fade} fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4.5" width="18" height="17" rx="2.6" />
        <path d="M3 10.25H21M8 2.75V6.25M16 2.75V6.25" />
      </g>
      {/* Заполненный вид (активный раздел): сплошной лист и короткие «колечки» над ним с ровным зазором — без вырезов в листе. */}
      <g opacity={solid ? 1 : 0} style={fade}>
        <rect x="3.2" y="5.6" width="17.6" height="15.7" rx="2.8" fill="currentColor" mask={`url(#${id}c)`} />
        <path d="M8 2.5V4.5M16 2.5V4.5" stroke="currentColor" strokeWidth={2.1} strokeLinecap="round" />
      </g>
    </GlyphSvg>
  );
}

const INBOX_TRAY = 'M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11Z';
const INBOX_SLOT = 'M22 12h-6l-2 3h-4l-2-3H2';

function InboxGlyph({ weight, ...rest }: GlyphProps) {
  const id = useId();
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <mask id={`${id}i`}>
        <rect width="24" height="24" fill="#fff" />
        <path d={INBOX_SLOT} fill="none" stroke="#000" strokeWidth={1.7} strokeLinejoin="round" />
      </mask>
      <g opacity={solid ? 0 : 1} style={fade} fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <path d={INBOX_TRAY} />
        <path d={INBOX_SLOT} />
      </g>
      <path d={INBOX_TRAY} fill="currentColor" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" mask={`url(#${id}i)`} opacity={solid ? 1 : 0} style={fade} />
    </GlyphSvg>
  );
}

/** Значки, которые в активном состоянии заливаются сплошь, как «Главная»; у остальных заливка лёгкая. */
const SOLID_FILL: ReadonlySet<IconName> = new Set<IconName>(['sparkles', 'trophy', 'users', 'compass', 'plug']);
/**
 * «Ассистент» — цельная мягкая четырёхлучевая звезда с точкой-спутницей: один знак ИИ для полосы, окна поиска, панели и подсказок.
 * Единственный значок продукта без контурного вида (исключение для знака ИИ).
 */
/** Контур мягкой четырёхлучевой звезды: центр, радиус луча. Вогнутые бока, кончики скругляет обводка. */
function sparkStar(cx: number, cy: number, r: number): string {
  const f = (n: number) => String(Math.round(n * 100) / 100);
  const k = 0.14;
  const m = 0.42;
  return `M${f(cx)} ${f(cy - r)}C${f(cx + r * k)} ${f(cy - r * m)} ${f(cx + r * m)} ${f(cy - r * k)} ${f(cx + r)} ${f(cy)}C${f(cx + r * m)} ${f(cy + r * k)} ${f(cx + r * k)} ${f(cy + r * m)} ${f(cx)} ${f(cy + r)}C${f(cx - r * k)} ${f(cy + r * m)} ${f(cx - r * m)} ${f(cy + r * k)} ${f(cx - r)} ${f(cy)}C${f(cx - r * m)} ${f(cy - r * k)} ${f(cx - r * k)} ${f(cy - r * m)} ${f(cx)} ${f(cy - r)}Z`;
}
const SPARK_BIG = sparkStar(10.5, 13.5, 8.2);

/** Знак ИИ — всегда цельный (залитый), без контурного вида: состояние показывает цвет, а не заливка. */
function SparkGlyph({ size, label, className, style }: GlyphProps) {
  const rest = { size, label, className, style };
  return (
    <GlyphSvg {...rest}>
      <g fill="currentColor" stroke="currentColor" strokeWidth={1.6} strokeLinejoin="round">
        <path d={SPARK_BIG} />
        <circle cx="19.2" cy="5" r="2.1" stroke="none" />
      </g>
    </GlyphSvg>
  );
}

/** «Сводка» как в Slack: острая звезда и две полоски текста под ней. */
function SummaryGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : weight === 'bold' ? 2.1 : 2.25;
  return (
    <GlyphSvg {...rest}>
      <g fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 1.8 L11.3 7.1 L16.6 9.4 L11.3 11.7 L9 17 L6.7 11.7 L1.4 9.4 L6.7 7.1 Z" />
        <path d="M3 20h18" />
        <path d="M3 23h11" />
      </g>
    </GlyphSvg>
  );
}

/** Крестик одним штрихом: два отдельных пути в WebKit оставляют светлый шов в месте пересечения, у одного контура его нет. */
function XGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : weight === 'bold' ? 2.1 : 2.25;
  return (
    <GlyphSvg {...rest}>
      <path d="M18 6 6 18M6 6l12 12" fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round" />
    </GlyphSvg>
  );
}

/** Генератор пароля как в Пассворке: две круговые стрелки и звёздочка пароля посередине. */
function PasswordGenGlyph({ weight, ...rest }: GlyphProps) {
  const line = weight === 'regular' ? 1.75 : weight === 'bold' ? 2.1 : 2.25;
  return (
    <GlyphSvg {...rest}>
      <g fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
        <path d="M21 3v5h-5" />
        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
        <path d="M8 16H3v5" />
        <path d="M12 9v6M9.4 10.5l5.2 3M14.6 10.5l-5.2 3" />
      </g>
    </GlyphSvg>
  );
}

const MAIL_BODY = 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z';
const MAIL_FLAP = 'm22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7';

/** Конверт, как в e-mail: в полосе — «Почта» (почта); активный — залитый, с белым «клапаном». */
function MailGlyph({ weight, ...rest }: GlyphProps) {
  const id = useId();
  const solid = weight === 'fill';
  const line = weight === 'regular' ? 1.75 : 2.1;
  return (
    <GlyphSvg {...rest}>
      <mask id={`${id}m`}>
        <rect width="24" height="24" fill="#fff" />
        <path d={MAIL_FLAP} fill="none" stroke="#000" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" />
      </mask>
      <g opacity={solid ? 0 : 1} style={fade} fill="none" stroke="currentColor" strokeWidth={line} strokeLinecap="round" strokeLinejoin="round">
        <path d={MAIL_BODY} />
        <path d={MAIL_FLAP} />
      </g>
      <path d={MAIL_BODY} fill="currentColor" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" mask={`url(#${id}m)`} opacity={solid ? 1 : 0} style={fade} />
    </GlyphSvg>
  );
}

/** Встроенный браузер: кольцо и игла компаса; в выбранном состоянии игла заливается сплошь (вариант D). */
const BROWSER_NEEDLE = 'M15.8 8.2 L13.4 13.4 L8.2 15.8 L10.6 10.6 Z';
function BrowserGlyph({ weight, ...rest }: GlyphProps) {
  const solid = weight === 'fill';
  return (
    <GlyphSvg {...rest}>
      <g fill="none" stroke="currentColor" strokeWidth={solid ? 2 : 1.7} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d={BROWSER_NEEDLE} fill="currentColor" fillOpacity={solid ? 1 : 0} style={{ transition: 'fill-opacity 0.18s var(--ease, ease)' }} />
      </g>
    </GlyphSvg>
  );
}

/** Кружок (видеосообщение): кольцо с разрывом, как таймер, и точка в центре. Камеры нет: она осталась за видеозвонком. */
const CIRCLE_NOTE_RING_DASH = '47 9.55';
function CircleNoteGlyph({ weight, ...rest }: GlyphProps) {
  return (
    <GlyphSvg {...rest}>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth={weight === 'regular' ? 2 : 2.3} strokeLinecap="round" strokeDasharray={CIRCLE_NOTE_RING_DASH} transform="rotate(-70 12 12)" />
      <circle cx="12" cy="12" r="3.2" fill="currentColor" />
    </GlyphSvg>
  );
}

export function Icon({ name, size = 18, weight = 'regular', label, className, style }: IconProps) {
  if (name === 'circleNote') return <CircleNoteGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'browser') return <BrowserGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'sparkles') return <SparkGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'summary') return <SummaryGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'key') return <KeyGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'textAa') return <TextAaGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'home') return <HomeGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'docs') return <DocsGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'chat') return <ChatGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'bell') return <BellGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'reply') return <ReplyGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'todoAdded') return <TodoAddedGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'calendar') return <CalendarGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'inbox') return <InboxGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'x') return <XGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'passwordGen') return <PasswordGenGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'mail') return <MailGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  if (name === 'todo') return <TodoGlyph size={size} weight={weight} label={label} className={className} style={style} />;
  const Svg = icons[name];
  return (
    <Svg
      size={size}
      strokeWidth={weight === 'regular' ? 1.75 : weight === 'bold' ? 2.1 : 2.25}
      fill={weight === 'fill' ? 'currentColor' : 'none'}
      fillOpacity={weight === 'fill' ? (SOLID_FILL.has(name) ? 1 : 0.18) : undefined}
      role={label === undefined ? undefined : 'img'}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
      focusable="false"
      className={className}
      style={style}
    />
  );
}
